import { memo, useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';

import { Search } from 'basic-components';
import { StatusesEnums } from 'dashboard-services/api/statuses';
import { loginActions } from 'primary-components';

import { statusesActions } from 'actions/modules/statuses';
import { routing } from 'routing';

import MainViewBlock from './MainViewBlock';

import { When } from 'react-if';

import './MainView.scss';

const MainView = () => {
  const dispatch = useDispatch(),
        searchRef = useRef(),
        [query, setQuery] = useState(""),
        getDataPrepsAccess = useMemo(() => dispatch(loginActions.hasAccessTo(routing.dataStorage.routing.list.name, "R", routing.dataStorage.name)), [dispatch]),
        getGroupsAccess = useMemo(() => dispatch(loginActions.hasAccessTo(routing.dataLake.routing.groups.name, "R", routing.dataLake.name)), [dispatch]),
        getPipelinesAccess = useMemo(() => dispatch(loginActions.hasAccessTo(routing.dataScience.routing.list.hashes.pipelines, "R", routing.dataScience.name)), [dispatch]),
        // A formula's runs open on the Monitor, so they need access to it.
        getFormulasAccess = useMemo(() => dispatch(loginActions.hasAccessTo(routing.dataScience.routing.dashboard.name, "R", routing.dataScience.name)), [dispatch])

  useEffect(() => {
    searchRef.current.focus()
  }, [])

  return (
    <div className="statuses__content statuses__main-view">
      <div className="statuses__main-view__search">
        <Search
            defaultValue={query}
            onSearch={setQuery}
            placeholder="Search statuses by group, pipeline, data prep or formula name"
            ref={searchRef}
            size="large"
            variant="outline"
        />
      </div>
      <div className="statuses__main-view__content">
        <When condition={getPipelinesAccess}>
          {() => (
            <MainViewBlock
                query={query}
                title="Pipelines"
                type={StatusesEnums.STATUS_TYPE.PIPELINE}
            />
          )}
        </When>
        <When condition={getGroupsAccess}>
          {() => (
            <MainViewBlock
                query={query}
                title="Groups"
                type={StatusesEnums.STATUS_TYPE.ETL}
            />
          )}
        </When>
        <When condition={getDataPrepsAccess}>
          {() => (
            <MainViewBlock
                query={query}
                title="Data preps"
                type={StatusesEnums.STATUS_TYPE.DATAPREP}
            />
          )}
        </When>
        <When condition={getFormulasAccess}>
          {() => (
            <MainViewBlock
                query={query}
                title="Formulas"
                type={statusesActions.FORMULA_TYPE}
            />
          )}
        </When>
      </div>
    </div>
  )
}

export default memo(MainView);